<!--
@create date 2024-1-2217
@desc A30.phomemo.com
-->
<template>
  <div class="m221-guide-div">
    <div class="topContainerDivEx">
      <h1>A30 LABEL PRINTER SUPPORT</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://pages.phomemo.com/resources/a30Machine.png"
            style="margin: 10px auto; width: 200px"
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <a
              style="font-weight: bold"
              @click="
                () => {
                  refreshRecord({ key: 'A30_ManualFile' });
                }
              "
              >Phomemo A30 Instruction Manual</a
            >
          </div>
          <p>
            Product registration is no longer necessary. Retain proof of
            purchase for warranty confirmation.
          </p>
          <hr
            style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
            v-show="!isMobile()"
          />
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer">
          Label Printer Component Overview&Installing the Ribbon Cartridge
        </div>
      </div>
      <div class="videosDivE">
        <!--       <div class="leftDiv">
        <img src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Labelife.png?v=1679475208" style="display:block;margin:0 auto;margin-bottom: 10px;margin-top: 26px;width:100px;"/>
        <a class="a-link">Labelife</a>
      </div>
      <div class="centerDiv">
         <a class="downloadBtn" href="https://www.labelife.net/#/download" target="_blank">
           <img src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/LabelifeBtn.png?v=1679469921" style="width: 330px;position:relative;top:0px" />
         </a>
      </div> -->
        <div
          class="rightDiv"
          style="float: left; margin-left: 11%; padding-top: 4%"
        >
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="A30_IntroVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/A30/1.%E5%A4%96%E8%A7%82%E4%BB%8B%E7%BB%8D-%E9%83%A8%E4%BB%B6%E5%B1%95%E7%A4%BA.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">App for Android / iOS</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 0">
          <img
            src="https://pages.phomemo.com/resources/a30/a30AppIntro.jpg"
            style="width: 590px; position: relative; top: 0px"
          />
        </div>
        <div class="rightDiv" style="padding-top: 4%">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="A30_APPVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/A30/2.%E6%89%8B%E6%9C%BA%E4%B8%8B%E8%BD%BDAPP%EF%BC%8C%E8%BF%9E%E6%8E%A5%E6%89%93%E5%8D%B0.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">Software for Windows / Mac</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://pages.phomemo.com/resources/a30/windows_icon.png"
            style="
              display: block;
              margin: 0 auto;
              margin-bottom: 10px;
              margin-top: 26px;
            "
          />
          <a class="a-link">Windows</a>
        </div>
        <div class="centerDiv">
          <a
            class="downloadBtn"
            href="https://www.labelife.net/#/download"
            target="_blank"
            @click="
              () => {
                refreshRecord({ key: 'A30_WinSoftware' });
              }
            "
          >
            <img
              src="https://pages.phomemo.com/resources/a30/downloadWindows.png"
              style="width: 330px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="A30_WinSoftwareVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/A30/4.Windows%E7%94%B5%E8%84%91%E7%AB%AF%E4%B8%8B%E8%BD%BD%E8%BF%9E%E6%8E%A5%E6%89%93%E5%8D%B0.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
        v-show="isMobile()"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://pages.phomemo.com/resources/a30/macIconPicture.png"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">macOS</a>
        </div>
        <div class="centerDiv">
          <a
            class="downloadBtn"
            href="https://www.labelife.net/#/download"
            target="_blank"
            @click="
              () => {
                refreshRecord({ key: 'A30_MacSoftware' });
              }
            "
          >
            <img
              src="https://pages.phomemo.com/resources/a30/downloadMac.png"
              style="width: 330px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="A30_MacSoftwareVideo"
          >
            <source
              src="https://web-video-1317518395.cos.na-ashburn.myqcloud.com/guideVideos/A30/3.MAC%20%E7%94%B5%E8%84%91%E7%AB%AF%E4%B8%8B%E8%BD%BD%E8%BF%9E%E6%8E%A5%E6%89%93%E5%8D%B0.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <!-- <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">Software for PC / Mac</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Labelife.png?v=1679475208"
            style="
              display: block;
              margin: 0 auto;
              margin-bottom: 10px;
              margin-top: 26px;
              width: 100px;
            "
          />
          <a class="a-link">Labelife</a>
        </div>
        <div class="centerDiv">
          <a
            class="downloadBtn"
            href="https://www.labelife.net/#/download"
            target="_blank"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/LabelifeBtn.png?v=1679469921"
              style="width: 330px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/3_03e17a05-8253-4684-ac1a-ab8df436f624.jpg?v=1683182599"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m221_3_labeife_guide_a.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div> -->

    <!-- <div class="howToVideosDiv faqBarDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div class="faq-item" v-for="(item, index) in faqDataApp">
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!--   联系方式 -->
    <!-- <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a href="mailto:support@phomemo.com">support@phomemo.com</a>
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+86 15338193665</div>
      <div class="everyRow" style="margin-top: 25px">
        Skype：Phomemo Team-Jessie
      </div>
      <div class="everyRow" style="margin-top: 25px">
        Service time：Mon-Fri 9AM-5PM (EST)
      </div>
    </div> -->
  </div>
</template>

<script>
const faqDataApp = [
  {
    title:
      "1. Why is my M221 not recognized by the computer after successful driver installation?",
    details: [
      {
        theme:
          "You need to connect M221 to your computer with cable first, and then install the driver.",
      },
    ],
  },
  {
    title: "2. Why the Bluetooth connection fails?",
    details: [
      {
        theme:
          "To connect the Phomemo M221 to your phone/tablet, you MUST first turn on Bluetooth and open Print Master app to connect to M221. It will fail if you connect directly in Bluetooth setting.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "3. Why it prints in blank?",
    details: [
      {
        theme: "It could be for these reasons：",
        imgUrls: [],
      },
      {
        theme:
          "1. The printing paper is upside down<br />- Please refer to the instruction manual: 05.Printer Paper Roll Installation.",
        imgUrls: [],
      },
      {
        theme:
          "2. The print head is damaged<br />- Please contact us for replacement;",
        imgUrls: [],
      },
    ],
  },
  {
    title: "4. Where do I buy refills？",
    details: [
      {
        theme:
          "You can search “Phomemo M221 Labels” or “Phomemo Labels” on Amazon and find original labels for it, or you can find links of labels in detial pages of M221.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "5. Why Print Master app keeps asking for location permission？",
    details: [
      {
        theme: "Note: This app won't collect any of your information.",
        imgUrls: [],
      },
      {
        theme:
          "If you are an Android user, you need to turn on location permission for searching Bluetooth devices to complete Bluetooth connection.",
        imgUrls: [],
      },
      {
        theme:
          "Google has strengthened users privacy policy, and requires users to enable some access permission to use Print Master, since the Android version of devices was updated to 10.0",
        imgUrls: [],
      },
    ],
  },
  {
    title: "6. How do I contact about issues of M221？",
    details: [
      {
        theme: "Please contact us through the following ways.",
        imgUrls: [],
      },
    ],
  },
];
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
import { refreshRecord, sensorsRecord } from "@/util.js";
export default {
  name: "A30",
  props: {},
  data() {
    return {
      faqDataApp,
      activeQuestion2: {},
      isMobile,
      window,
      refreshRecord,
    };
  },
  mounted() {
    this.listenVideo("A30_IntroVideo");
    this.listenVideo("A30_WinSoftwareVideo");
    this.listenVideo("A30_MacSoftwareVideo");
    sensorsRecord({ key: "A30_view" }, 1);
    sensorsRecord({ key: "A30_WebStay" }, 3);
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({ key: videoId });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./m221.less" />



// WEBPACK FOOTER //
// src/view/guides/A30.vue